module.exports = __webpack_public_path__ + "img/badge_image_master.ab2eb539.png";